import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesEnum } from '../enums/routes-enum';
import { AuthService } from '../services/auth.service';
import { SharedServiceService } from '../services/shared-service.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css'],
})
export class SideBarComponent implements OnInit {
  allTickets = [
    {
      label: 'Tickets Restaurant',
      icon: 'assets/resto.svg',
      route: '/company/titre-restaurant',
    },
    {
      label: 'Chèque cadeau entreprise',
      icon: 'assets/gift.svg',
      route: '/company/cheque-cadeau',
    },
    {
      label: 'Chèques Vacances',
      icon: 'assets/vacation.svg',
      route: '/company/cheque-vacances',
    },
    {
      label: 'Bon essence',
      icon: 'assets/station.svg',
      route: '/company/bon-essence',
    },
  ];

 
  private static cachedTickets: any[] | null = null;

  filteredTickets: any[] = SideBarComponent.cachedTickets ?? [];
  constructor(
    private sharedService: SharedServiceService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.authService.getUserInfos('company').subscribe((result) => {
      const normalize = (str: string) =>
        str
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim();

      const allowedLabels = result.data.company.tickets.map(
        (item: { label: string }) => normalize(item.label)
      );

      this.filteredTickets = this.allTickets.filter((ticket) =>
        allowedLabels.includes(normalize(ticket.label))
      );
      SideBarComponent.cachedTickets = this.filteredTickets;
    });
  }

  newMessage(title: string) {
    this.sharedService.changeMessage(title);
  }

  logout() {
    SideBarComponent.cachedTickets = null;
    this.authService.logout();
    this.router.navigate([RoutesEnum.signinRoute]);
  }
}
